export class GetLandingPageContent {
  constructor(repository) {
    this.repository = repository;
  }

  execute() {
    return this.repository.getLandingPageContent();
  }
}

